import React, { useEffect, useState, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import CCBAWeb from '@companycam/companycam-baweb';
import apiClient from 'helpers/api-client';
import { loadBAResourceDefs } from 'actions';
import { beforeAfterResources } from 'selectors/remoteResources';

const INVISIBLE_4X4_PNG =
  'https://companycam-static.s3.amazonaws.com/213a7cc9-44e0-4a32-8d35-3471d18b9e8b.png';

function loadPhoto(photoId) {
  const path = `images/${photoId}`;
  return apiClient.get(path).then((photo) => {
    return photo;
  });
}

const BeforeAfterPhotoModalContents = ({
  imageBeforeId,
  imageAfterId,
  companyId,
  onCancel,
  onSave,
}) => {
  const dispatch = useDispatch();
  const templateDefs = useSelector((state) => beforeAfterResources(state));

  const [loading, setLoading] = useState(true);
  const [imageBefore, setImageBefore] = useState(null);
  const [imageAfter, setImageAfter] = useState(null);
  const [imageLogo, setImageLogo] = useState(null);

  const fetchImageLogoUrl = useCallback(() => {
    return apiClient.get(`companies/${companyId}`).then((company) => {
      setImageLogo(company.logo_small_url || INVISIBLE_4X4_PNG);
    });
  }, [companyId, setImageLogo]);

  const fetchImageBeforeUrl = useCallback(() => {
    return loadPhoto(imageBeforeId).then((photo) => {
      setImageBefore(photo.url_large);
    });
  }, [imageBeforeId]);

  const fetchImageAfterUrl = useCallback(() => {
    return loadPhoto(imageAfterId).then((photo) => {
      setImageAfter(photo.url_large);
    });
  }, [setImageAfter, imageAfterId]);

  useEffect(() => {
    dispatch(loadBAResourceDefs());
    Promise.all([
      fetchImageLogoUrl(),
      fetchImageBeforeUrl(),
      fetchImageAfterUrl(),
    ])
      .then(() => {
        setLoading(false);
      })
      .catch(() => {
        onCancel();
      });
  }, [
    dispatch,
    fetchImageLogoUrl,
    fetchImageBeforeUrl,
    fetchImageAfterUrl,
    onCancel,
  ]);

  if (loading) {
    return (
      <div className="data-loading-wrap">
        <div className="data-loading loading-over-dark-background">
          <i className="mdi mdi-loading" />
          <FormattedMessage id="Common.loading" />
        </div>
      </div>
    );
  }

  return (
    <div>
      {!loading && templateDefs.length > 0 && (
        <CCBAWeb
          templateDefs={templateDefs}
          imageBefore={imageBefore}
          imageAfter={imageAfter}
          imageLogo={imageLogo}
          onCancelChooser={onCancel}
          onSave={onSave}
        />
      )}
    </div>
  );
};

BeforeAfterPhotoModalContents.propTypes = {
  imageBeforeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  imageAfterId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  companyId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  onCancel: PropTypes.func,
  onSave: PropTypes.func,
};

export default BeforeAfterPhotoModalContents;
